import { channelChips, channelCounts } from './format'

/**
 * The channels one message travelled on.
 *
 * A failed chip is not an error the manager has to act on — it is half of the
 * sentence the next chip finishes («ایتا ناموفق», «پیامک، جایگزین پیام‌رسان»).
 * So it is tinted, not shouted.
 */
export function ChannelChips({
    channels,
}: {
    channels?: IMessagingChannelDelivery[] | null
}) {
    const chips = channelChips(channels)
    if (chips.length === 0) return null
    return (
        <div className=" mt-2 flex flex-wrap items-center gap-1.5">
            {chips.map((chip) => (
                <span
                    key={chip.key}
                    className={` rounded-full px-2 py-0.5 text-[11px] ${
                        chip.failed
                            ? ' bg-danger-soft text-danger-on'
                            : ' bg-main-bg text-text-secondary'
                    }`}
                >
                    <span>{chip.label}</span>
                    {chip.failed && <span className=" mr-1">ناموفق</span>}
                    {chip.seen && (
                        <span className=" mr-1 font-bold text-green-1">
                            دیده شد
                        </span>
                    )}
                    {chip.caption && (
                        <span className=" mr-1 text-text-muted">
                            {chip.caption}
                        </span>
                    )}
                </span>
            ))}
        </div>
    )
}

/** «پیامک ۴ پیام‌رسان ۳» — the counting counterpart, one pill per group. */
export function ChannelCountChips({
    counts,
}: {
    counts?: TMessagingChannelCounts | null
}) {
    const items = channelCounts(counts)
    if (items.length === 0) return null
    return (
        <div className=" mt-1.5 flex flex-wrap items-center gap-1.5">
            {items.map((item) => (
                <span
                    key={item.key}
                    className=" rounded-full bg-main-bg px-2 py-0.5 text-[11px] text-text-secondary"
                >
                    {item.text}
                </span>
            ))}
        </div>
    )
}
